import { useIntegration } from './useIntegration'

export function useActiveChatIntegration(): 'chatbot' | 'livechat' | null {
	const { integration: chatbot } = useIntegration('chatbot')
	const { integration: livechat } = useIntegration('livechat')

	if (livechat?.connected) {
		return 'livechat'
	}

	if (chatbot?.connected) {
		return 'chatbot'
	}

	return null
}
